import "~assets/styles/bootstrap/bootstrap.min.css";

import "./app";
